import React from "react";

/**
 * 作業件数サマリーコンポーネント
 * @param {number} unfinishedCount 未完了作業件数
 * @param {number} unfinishedCount 差立作業件数
 * @param {string} workerName 作業者名
 * @class Summary
 */
export default function Summary({
  unfinishedCount = 0,
  dispatchCount = 0,
  workerName,
}) {
  return (
    <div className="summary-grid" aria-label="作業件数サマリー">
      <div className="summary-card">
        <div>
          <p className="summary-label">未完了作業</p>
          <p className="summary-value">{`${unfinishedCount}件`}</p>
        </div>
        <div className="summary-icon" aria-hidden="true">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M8 6h13M8 12h13M8 18h13"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M3 6h.01M3 12h.01M3 18h.01"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>

      <div className="summary-card">
        <div>
          <p className="summary-label">差立作業</p>
          <p className="summary-value">{`${dispatchCount}件`}</p>
        </div>
        <div className="summary-icon" aria-hidden="true">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M6 3v4M18 3v4M4 9h16M6 21h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>

      <div className="summary-card">
        <div>
          <p className="summary-label">作業者</p>
          <p className="summary-value">{workerName}</p>
        </div>
        <div className="summary-icon" aria-hidden="true">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M20 21a8 8 0 0 0-16 0"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle
              cx="12"
              cy="8"
              r="4"
              stroke="currentColor"
              strokeWidth="2"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
